module.exports = __webpack_public_path__ + "static/img/mobilesc-CIF21pF9.7abe208.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/mobilesc-CIF21pF9.png
// module id = xY9c
// module chunks = 16